import { Component, Input } from '@angular/core';
import { AdPlacementRoadOccupationFormValue } from '../../forms/ad-placement-road-occupation.form';
import {DatePipe, DecimalPipe} from '@angular/common';
import { LabelComponent } from '../../../../../../../../common/label/label.component';
import {
  ParcelsPreviewComponent
} from '../../../../../common/components/parcels/parcels-preview/parcels-preview.component';
import { last } from 'rxjs';
import {ToNumberPipe} from "../../../../../../../../pipes/to-number.pipe";

@Component({
  selector: 'app-ad-placement-occupation-preview',
  standalone: true,
  imports: [
    DatePipe,
    LabelComponent,
    ParcelsPreviewComponent,
    DecimalPipe,
    ToNumberPipe
  ],
  templateUrl: './ad-placement-occupation-preview.component.html'
})
export class AdPlacementOccupationPreviewComponent {

  @Input()
  public occupation: AdPlacementRoadOccupationFormValue | undefined;
  protected readonly last = last;
}
